const colorSchemes = {
  industry: "purple",
  keyword: "orange",
  stage: "teal",
  private: "red",
  public: "yellow",
  company: "blue",
  investor: "green",
  funding: "orange",
  deal: "yellow",
  nonProfit: "lime",
  stateOwned: "cyan",
  wealth: "cyan",
  contact: "gray",
  investorContact: "gray",
  people: "purple",
} as const;

export type ColorSchemeType = keyof typeof colorSchemes;

export type ColorScheme = typeof colorSchemes[ColorSchemeType];

export const isColorSchemeType = (str: string): str is ColorSchemeType =>
  (str as ColorSchemeType) in colorSchemes;

export default colorSchemes;
